import React from 'react';
import './uk.css'; // Import the CSS for styling

const UnitedKingdom = () => {
  return (
    <div className="unitedkingdom-page">
      <header className="unitedkingdom-header">
        <h1>Study in the United Kingdom</h1> {/* Header for the page */}
      </header>
      <main className="unitedkingdom-content">
        <section className="unitedkingdom-section">
          <h2>Prestigious Universities</h2>
          <p>
            The UK has a long-standing tradition of excellence in higher education, 
            with universities like Oxford, Cambridge, and Imperial College London 
            consistently ranked among the best in the world. These institutions are 
            known for their rich history, rigorous academics, and cutting-edge research.
          </p>
        </section>
        <section className="unitedkingdom-section">
          <h2>Cultural and Historical Experience</h2>
          <p>
            Studying in the UK offers an unparalleled opportunity to experience 
            centuries of history, vibrant culture, and diverse societies. You’ll not 
            only receive a top-notch education but also immerse yourself in a culturally 
            rich environment.
          </p>
        </section>
        <section className="unitedkingdom-section">
          <h2>Shorter Degree Programs</h2>
          <p>
            Many degree programs in the UK are shorter in duration compared to other 
            countries, allowing students to graduate and enter the workforce more quickly, 
            saving both time and money.
          </p>
        </section>
      </main>
      <footer className="unitedkingdom-footer">
        <p>Explore your potential while studying in the historic United Kingdom!</p>
      </footer>
    </div>
  );
};

export default UnitedKingdom;
